import CustomTimeDateModal from './custom-time-date-modal.connect'

export default CustomTimeDateModal
